import { render, staticRenderFns } from "./NameInput.vue?vue&type=template&id=540e2440&scoped=true"
import script from "./NameInput.vue?vue&type=script&lang=js"
export * from "./NameInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540e2440",
  null
  
)

export default component.exports